import * as React from "react";
const SvgIconNodeDiamond = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "currentColor", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 2L2 12l10 10 10-10L12 2z" }));
export { SvgIconNodeDiamond as ReactComponent };
